<template>
  <div class="organ-head clearfix">
    <div class="img-bg">
      <img
        :src="organMsg.orgCoverImgPath | filterImageBaseURL(showImgUrl)"
        alt="易极云课堂"
      />
    </div>
    <div class="content-wrapper clearfix">
      <div class="pic">
        <img
          :src="organMsg.orgHeaderImgPath | filterImageBaseURL(showImgUrl)"
          alt="易极云课堂"
        />
      </div>
      <div class="content">
        <h3>{{ organMsg.orgName }}</h3>
        <!--<span v-for="item in organMsg.orgTypeNameList.slice(0,3)">{{item }}</span>-->
        <span>{{ organMsg.orgTypeNameList.slice(0, 3).toString() }}</span>
        <p>{{ organMsg.orgSignature }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import global from "@/common/js/global";
export default {
  data() {
    return {
      showImgUrl: global.imgUrl
    };
  },
  props: {
    organMsg: {
      type: Object,
      default: function() {
        return {
          orgName: "赤云社",
          id: "0",
          orgSignature:
            "赤云社和昼研社是两个不同的课程。线下叫赤云创意设计研习社，线上叫昼研社/灰昼C4D。",
          orgHeaderImgPath: "static/testImg/teacher.png",
          orgTypeName: "培训机构",
          orgCoverImgPath: "static/img/organBg.png"
        };
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss" scoped>
@import "~@/styles/base.scss";
.organ-head {
  position: relative;
  padding-top: 55px;
  height: 240px;
  width: 100%;
  box-sizing: border-box;
  border-bottom: solid 1px #ededed;
  .img-bg {
    position: absolute;
    overflow: hidden;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    height: 240px;
    text-align: center;
    background-color: rgba(0, 0, 0, 0.8);
    img {
      width: 100%;
      height: 240px;
      opacity: 0.2;
      filter: blur(5px);
    }
  }
  .pic {
    float: left;
    overflow: hidden;
    width: 128px;
    height: 128px;
    /*border-radius: 50%;*/
    /*border: solid 3px #EDEDED;*/
    line-height: 128px;
    text-align: center;
    img {
      width: 128px;
      width: 128px;
      height: 128px;
      border-radius: 50%;
      border: solid 3px #ededed;
    }
  }
  .content-wrapper {
    width: 1200px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  .content {
    margin: 30px 0 0 45px;
    float: left;
    color: #fff;
    h3 {
      display: inline-block;
      font-size: 30px;
      line-height: 30px;
    }
    span {
      display: inline-block;
      vertical-align: top;
      /*width: 90px;*/
      width: auto;
      padding: 0px 20px;
      height: 30px;
      margin-left: 20px;
      color: #fff;
      text-align: center;
      line-height: 30px;
      font-size: 16px;
      border-radius: 3px;
      background-color: #008bfb;
    }
    p {
      margin-top: 25px;
      width: 786px;
      font-size: 16px;
      line-height: 1.5em;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organ-head/organ-head.vue